<!-- <ion-content> -->

  


  <div  class="attr_div bg_content">
    <div class="d__flex just-s header__">
      <h5 class="header m-0">{{is_attr ? 'Add Options' :'Variants'}}</h5>
      <ion-icon (click)="modalCtrl.dismiss()" name="close-outline"></ion-icon>
    </div>

    <app-no-record-found class="w-100" *ngIf="!is_attr && (product && product.product_attributes && product.product_attributes.length == 0)" [column]="true" [height]="DBservice.ismobile ? 'calc(100vh - 80px)' : 'calc(100vh - 80px)'" heading="There’s no variants found" [image]="'assets/no_variant.svg'"></app-no-record-found>


      <div  class="content" *ngIf="is_attr">
        <ion-list *ngIf="(product && product.product_attributes && product.product_attributes.length < 3) || product == {}">
          <ion-item *ngFor="let data of all_attributes" (click)="add_new_attr(data)" lines="none" class="pl0">
            <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            <ion-label>
              <h6 class="headertexth6">{{data.attribute_name}}</h6>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
      <div *ngIf="!is_attr && (product && product.product_attributes && product.product_attributes.length != 0)" class="content">
        <div (click)="add_attribute()" *ngIf="false && (product && product.product_attributes && product.product_attributes.length < 3) || product == {} " class="mb-10 add_variations just-s d__flex background_white">
          <h5 class="h5 m-0">Add Options</h5>
          <ion-icon class="f18" name="add-outline"></ion-icon>
          <!-- <ion-button (click)="add_attribute()" fill="clear"><ion-icon name="add-outline"></ion-icon></ion-button> -->
          <div *ngIf="false" class="d__flex variations" >
            <div *ngFor="let data of (view_more ? all_attributes : all_attributes.slice(0,4))" (click)="add_new_attr(data)" class="add__ variations_box mouse  d__flex just-s">
              <p class="m-0 p_title">{{data.attribute_name}}</p>
              <ion-icon name="add-outline"></ion-icon>
              <!-- <div *ngIf="data.show" class="hover">
              <p class="m-0 add mouse">Add</p>
            </div> -->
            </div>
            <div *ngIf="all_attributes.length > 4" (click)="view_more =! view_more" class="menu d__flex variations_box mouse">
              <ion-icon name="apps-outline"></ion-icon>
              <p class="m-0 view_more">{{view_more ? 'View Less' : 'View More'}}</p>
            </div>
          </div>
        </div>
        <div *ngIf="product && product.product_attributes && product.product_attributes.length != 0" [class.div_2]="product.product_attributes.length == 2" [class.div_3]="product.product_attributes.length == 3" class="attribute_div">
          <div *ngFor="let item of product.product_attributes;let i = index" class="attribute_box mb-10">
            <div (click)="show_more(i,item)" class="add_variations mouse just-s d__flex background_white">
              <h5 class="h5 m-0">{{item.attribute || item.attribute_name}}</h5>
              <!-- <ion-icon class="del_icon" color="danger" src="assets/icons/delete.svg"></ion-icon> -->
              <ion-icon class="f18" [name]="!item.more_ ?'chevron-down-outline':'chevron-up-outline'"></ion-icon>
            </div>
            <!-- <ion-icon name="chevron-down-outline"></ion-icon> -->
            <div class="d__flex box__" *ngIf="item.more_">
  
              
              <div class="box__1">
                <div class="d__flex just-s">
                  <span class="fnt-13">Option value</span>
                  <h6 (click)="delete__attr(i,product.product_attributes)" class="h6 mouse features del m-0">Delete</h6>
                </div>
                <div *ngIf="false" class="attr_hear d__flex just-s">
                  <h6 *ngIf="item.attribute || item.attribute_name" class="h6 m-0">{{item.attribute || item.attribute_name}}</h6>
                  <div class="d__flex features__con">
                    <h6 *ngIf="false" (click)="edit__attr()" class="h6 mouse features m-0">Edit</h6>
                    <h6 (click)="delete__attr(i,product.product_attributes)" class="h6 mouse features del m-0">Delete</h6>
                  </div>
                </div>
                <div *ngIf="false && item.all_options && item.all_options.length != 0" lines="none" class="custom-input d__flex">
                 
                  <select class="form-input form-select" interface="popover" (change)="value_changed($event,item)">
                    <option *ngFor="let c of item.all_options" value="{{c.options}}">{{c.options}}</option>
                    <option value="all">Add all options</option>
                  </select>
  
                  <ion-icon (click)="item.add_new = true" class="mouse" name="add-outline"></ion-icon>
                </div>
  
                <div (click)="open_variants_pop_up(item.all_options,item)" *ngIf="item.all_options && item.all_options.length != 0"  class="mouse d__flex pick_f ion-activatable ripple-parent rectangle">
                   <ion-ripple-effect></ion-ripple-effect>
                   <p class="m-0 p_tag">Pick From List</p>
                   <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
  
                <!-- *ngIf="item.add_new || (item.all_options && item.all_options.length == 0)" -->
                <div  lines="none" class="custom-input custom-input_1 d__flex">
                  <ion-input [(ngModel)]="item.option_values" placeholder="create options"></ion-input>
                  <p (click)="add_option(item)" class="mouse p_title">Add</p>
                </div>
                <p *ngIf="item.alert" class="error m-0">{{item.alert_msg}}</p>
                <div *ngIf="false" class="d__flex check_box__ mouse">
                  <ion-checkbox class="check__box" (ionChange)="item.is_active =! item.is_active" [checked]="item.is_active"></ion-checkbox>
                  <p class="m-0 check_box_value">Prices vary for each {{item.attribute}} </p>
                </div>
              </div>
              <div *ngIf="item.options && item.options.length != 0" class="box__2">
                <div *ngFor="let c of item.options;let i = index" class="categories_box__ d__flex">
                  <p  class="m-0 p_title d__flex just-s">{{c.option_value}}</p>
                  <span (click)="remove(item,i)" class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!is_attr && (product && product.product_attributes && product.product_attributes.length != 0)" class="buttons__">
        <ion-button expand="block" (click)="save_data()" class="save_b">Save</ion-button>
      </div>
   


    <ion-fab (click)="add_attribute()" *ngIf="!is_attr && (product && product.product_attributes && product.product_attributes.length < 3) || product == {} "  class="fab" slot="fixed" vertical="bottom" horizontal="end">
      <ion-fab-button>
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>

  </div>

<!-- </ion-content> -->
<!-- <ion-footer translucent="true" class="ion-no-border" >
  <ion-toolbar translucent="true"  >
   <div class="d__flex buttons__">
    <ion-button (click)="save_data()" class="save_b" fill="clear">Save</ion-button>
  </div>
  </ion-toolbar>
</ion-footer> -->
<!-- <div *ngIf="product.item && product.product_attributes;else no_item;">
  <div class="d__flex myform product__attribute gap-10 mb-10" *ngFor="let item of product_variants;let i = index" >
    <ion-select placeholder="attribute" interface="popover"  [(ngModel)]="item.product_attribute" (ionChange)="attribute_changed($event,i)">
      <ion-select-option  *ngFor="let v of Product_attributes" [value]="v.name">{{v.attribute_name}}</ion-select-option>
    </ion-select>

    


    <ion-select placeholder="attribute type" interface="popover"  [(ngModel)]="item.control_type" (ionChange)="add_attribute()">
      <ion-select-option  *ngFor="let v of attributes" [value]="v">{{v}}</ion-select-option>
    </ion-select>
  
    <div class="options_input">
      <span class="attribute-options" *ngFor="let ops of item.options">
         <span class="attribute-option"> {{ops.option_value}} </span> 
         <ion-icon name="close-outline" (click)="remove_attribute(ops)"></ion-icon> 
      </span>
      <ion-input class="fnt-12" (ionChange)="add_options($event,item)"  placeholder="separate options with comma"></ion-input>
    </div>
    <div>
      <ion-button color="success" size="small" class="ion-text-capitalize" (click)="edit_attribute(item)">Edit</ion-button>
      <ion-button color="danger" size="small" class="ion-text-capitalize">Delete</ion-button>
    </div>
  </div>
</div>
<ng-template #no_item>
  <p class="ion-text-center">No Attributes Found.!</p>
</ng-template> -->
<!-- <div class="ion-text-right">
  <ion-button class="ion-text-capitalize fnt-12" size="small" (click)="add_new()">Add attribute</ion-button>
  <ion-button class="ion-text-capitalize fnt-12" size="small" (click)="generate_combinations()">Generate Combinations</ion-button>
</div> -->
<!-- <div *ngIf="product && product.product_variant && product.product_variant.length != 0">
<h6>COMBINATIONS</h6>
<table>
  <tr>
    <th>Attribute</th>
    <th>Stock Qty</th>
    <th>Weight (In gram)</th>
    <th>Price</th>
    <th>SKU</th>
    <th class="border-none">Actions</th>
  </tr>
  <tr *ngFor="let item of product.product_variant">
    <td class="fnt-14" [innerHTML]="item.attribute_html">
    </td>

    

    <td><ion-input [(ngModel)]="item.stock"></ion-input></td>
    <td><ion-input [(ngModel)]="item.weight"></ion-input></td>
    <td><ion-input [(ngModel)]="item.price"></ion-input></td>
    <td><ion-input [(ngModel)]="item.sku"></ion-input></td>
    <td class="border-none d__flex ion-align-items-center"> 
      <ion-button color="success" fill="clear"  *ngIf="product.product_variant.length !=0"  size="small" class="ion-text-capitalize" (click)="edit_variant()">Edit</ion-button>
      <ion-button color="danger" fill="clear"  size="small" class="ion-text-capitalize">Delete</ion-button>
    </td>
  </tr>
</table>


</div> -->
